import { apiWithPrefix as api } from '../utils/api';

export class HolidayService {
  static async getMergedHolidays(year = new Date().getFullYear()) {
    const response = await api.get('/holidays/merged', {
      params: { year }
    });
    return response.data;
  }

  static async createHoliday(data) {
    const response = await api.post('/holidays', data);
    return response.data;
  }

  static async updateHoliday(id, data) {
    const response = await api.put(`/holidays/${id}`, data);
    return response.data;
  }

  static async deleteHoliday(id) {
    const response = await api.delete(`/holidays/${id}`);
    return response.data;
  }

  static async approveHoliday(id) {
    const response = await api.post(`/holidays/${id}/approve`);
    return response.data;
  }
}

export default HolidayService;
